import SectionHeading from './SectionHeading';
import { photoCollections } from '@/mocks/mikami/photos';

export default function PhotosSection() {
  return (
    <section id="photos" className="anchor-offset bg-background-100 py-14 md:py-20">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="写真合集"
          title="按色调与场景划分的写真影像"
          description="写真合集以视觉偏好为线索，分为柔光、暖调外景、金调质感与暗调氛围四类。每类标注了主要风格与适合的浏览场景，方便按喜好直接挑选。"
        />

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {photoCollections.map((item) => (
            <article key={item.id} className="group overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <div className="relative h-64 w-full overflow-hidden md:h-72">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-0.5 text-xs font-label text-foreground-800">
                  {item.category}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                  <span className="text-xs text-foreground-500">{item.period}</span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.note}</p>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-6 rounded-lg border border-secondary-200 bg-secondary-50 px-4 py-3 text-xs leading-relaxed text-secondary-900 md:text-sm">
          <i className="ri-image-line mr-1"></i>
          上图为风格示意概念图，用于表达各合集的色调与氛围方向，并非实际写真画面。
        </p>
      </div>
    </section>
  );
}